// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__2w817","container":"Error_container__1cM0o","icon":"Error_icon__shVP6","text":"Error_text__1crp0","button":"Error_button__1-J4H"};